export const ImageDispatcher = ({ src, ...props }) => (
  <img src={_fixSrc(src)} {...props} />
);

const urlsToReplace = [
  'https://cdn.farmakom.io',
  'https://api.farmakom.io',
  'https://api.farmakom.it',
  'https://api2.farmakom.it',
];

const _fixSrc = src => {
  if (!!src && urlsToReplace.some(url => src.includes(url))) {
    return urlsToReplace.reduce((acc, url) => acc.replace(url, ''), src);
  } else {
    return src;
  }
};
